<div class="row" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/hourglass/tools'">
      <i class="fas fa-fw fa-lock me-2"></i>Admin Tools<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <span class="c_bluedk"><i class="fas fa-fw fa-clock mx-2"></i>MinutesMaker</span>
    <span class="ms-3 badge">{{editorMode.toUpperCase() + ' MODE'}}</span>
  </div>
</div>
<div class="row mb-2">
  <div class="col-12">
    <div class="card mt-2">
      <div class="card-header bg_blue p-2 d-none">
        <div class="row">
          <div class="col-9 c_white">
            <label class="mt-1"><i class="fas fa-fw fa-clock mx-2"></i>MinutesMaker</label>
            <span class="ms-3 badge">{{editorMode.toUpperCase() + ' MODE'}}</span>
          </div>
          <div class="col-3 text-end">
            <button type="button" class="btn btn-sm btn-primary" title="Toggle Saved Minutes Panel" (click)="toggleEditor()">
              <i [ngClass]="(showMinutesEditor) ? 'fas fa-fw fa-chevron-up' : 'fas fa-fw fa-chevron-down'"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body p-2" [ngClass]="(showMinutesEditor) ? 'd-block' : 'd-none'">
        <div class="row mb-2">
          <div class="col-12 col-md-6">
            <div class="row" *ngIf="(errorMsg != '')">
              <div class="col-12">
                <div class="alert alert-danger p-2 mb-2 text-center" [(ngModel)]="errorMsg"><strong>{{errorMsg}}</strong></div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <input [readonly]="true" [(ngModel)]="minutesForm.meetingTitle"
                       type="text"
                       class="form-control form-control-lg p-2 bg_blue c_white"
                       placeholder="Meeting Title" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-6">
                <label class="my-1 c_blue"><i class="fas fa-fw fa-calendar me-2"></i>Date</label>
                <input type="date" [(ngModel)]="minutesForm.meetingDate"
                       class="form-control form-control-sm"
                       placeholder="Enter Meeting Date"
                       (change)="onDateChanged()" />
              </div>
              <div class="col-12 col-md-6">
                <label class="my-1 c_blue"><i class="fas fa-fw fa-building me-2"></i>Division</label>
                <ng-multiselect-dropdown [placeholder]="'Select Division'"
                                         [settings]="ddSettingsDivision"
                                         [data]="listDivisions"
                                         [(ngModel)]="minutesForm.meetingDivision"
                                         (onSelect)="onDivisionSelect($event)"
                                         (onDeSelect)="onDivisionDeselect($event)"
                                         style="width:500px">
                </ng-multiselect-dropdown>
              </div>

            </div>
            <div class="row mb-2">
              <div class="col-12">
                <label class="my-1 c_blue"><i class="fas fa-fw fa-pen me-2"></i>Topic</label>
                <input type="text" [(ngModel)]="minutesForm.meetingTopic"
                       class="form-control form-control-sm"
                       placeholder="Enter Meeting Topic"
                       (blur)="formatTitle()" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-6">
                <label class="my-1 c_blue"><i class="fas fa-fw fa-user me-2"></i>Client</label>
                <ng-multiselect-dropdown [placeholder]="'Select Client'"
                                         [settings]="ddSettingsClient"
                                         [data]="listClients"
                                         [(ngModel)]="minutesForm.existingClient"
                                         (onSelect)="onClientSelect($event)"
                                         (onDeSelect)="onClientDeselect($event)"
                                         style="width:500px">
                </ng-multiselect-dropdown>
              </div>
              <div class="col-12 col-md-6">
                <label class="my-1 c_white">New Client Name</label>
                <input type="text" [(ngModel)]="minutesForm.newClientName" class="form-control form-control-sm" placeholder="OR Enter Client Name" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-6">
                <label class="my-1 c_blue"><i class="fas fa-fw fa-handshake me-2"></i>Type</label>
                <ng-multiselect-dropdown [placeholder]="'Select Meeting Type'"
                                         [settings]="ddSettingsLocation"
                                         [data]="listLocations"
                                         [(ngModel)]="minutesForm.meetingLocation"
                                         (onSelect)="onLocationSelect($event)"
                                         (onDeSelect)="onLocationDeselect($event)"
                                         style="width:500px">
                </ng-multiselect-dropdown>
              </div>
              <div class="col-12 col-md-6" *ngIf="minutesForm.showLocationEntry">
                <label class="my-1">Meeting Location</label>
                <input type="text" [(ngModel)]="minutesForm.meetingLocationName" class="form-control form-control-sm" placeholder="Enter Location" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-8">
                <label class="my-1 c_blue"><i class="fas fa-fw fa-users me-2"></i>Attendees</label>
                <ng-multiselect-dropdown [placeholder]="'Select Welara Attendees'"
                                         [settings]="ddSettingsUser"
                                         [data]="listUsers"
                                         [(ngModel)]="selectedUsers"
                                         (onSelect)="onUserSelect($event)"
                                         (onDeSelect)="onUserDeselect($event)">
                </ng-multiselect-dropdown>

              </div>
              <div class="col-12 col-md-4">
                <label class="my-1 c_white">spacer</label>
                <button class="btn btn-sm btn-primary" (click)="addParty()" style="width:100%">
                  <i class="fas fa-fw fa-user-plus me-2"></i>Add Party
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="grid_sizer" id="sizeParties" style="height:25vh">
                  <ag-grid-angular class="ag-theme-alpine"
                                   [rowData]="rowData"
                                   [columnDefs]="columnDefs"
                                   [getRowStyle]="getRowStyle"
                                   [rowHeight]="28"
                                   [headerHeight]="32"
                                   (gridReady)="onGridReady($event)"
                                   [rowSelection]="rowSelection"
                                   (selectionChanged)="onSelectionChanged($event)"
                                   style="width: 100%;height:100%;border:0 !important">
                  </ag-grid-angular>
                </div>
              </div>
            </div>
            <div class="row my-2 d-none">
              <div class="col-12">
                <label class="my-1 c_blue"><i class="fas fa-fw fa-user-minus me-2"></i>Absentees</label>
                <textarea class="form-control form-control-sm" [(ngModel)]="minutesForm.content_absentees" rows="2"></textarea>
              </div>
            </div>

          </div>
          <div class="col-12 col-md-6">
            <div class="card">
              <div class="card-body bg_light p-2">
                <div class="row mb-2">
                  <div class="col-12 col-md-6">
                    <div class="mark_downer">
                      <label class="mt-1 mb-2 c_blue">
                        <i class="fas fa-fw fa-paperclip me-2"></i>Materials Distributed
                        <i class="fas fa-fw fa-search-plus mx-2 p-2 pointer" title="Show Rendered Content" (click)="togglePreview('materials')"></i>
                      </label>
                      <textarea class="form-control form-control-sm"
                                [(ngModel)]="minutesForm.content_materials"
                                (ngModelChange)="onMarkdownChange('materials')"
                                style="height:25vh">
                      </textarea>
                    </div>
                    <div *ngIf="minutesForm.show_materials" class="p-2 markup_scroll" [innerHTML]="html_materials" style="height:15vh;background:#f0f0f0"></div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mark_downer">
                      <label class="mt-1 mb-2 c_blue">
                        <i class="fas fa-fw fa-list me-2"></i>Agenda
                        <i class="fas fa-fw fa-search-plus mx-2 p-2 pointer" title="Show Rendered Content" (click)="togglePreview('agenda')"></i>
                      </label>
                      <textarea class="form-control form-control-sm"
                                [(ngModel)]="minutesForm.content_agenda"
                                (ngModelChange)="onMarkdownChange('agenda')"
                                style="height:25vh"></textarea>
                    </div>
                    <div *ngIf="minutesForm.show_agenda" class="p-2 markup_scroll" [innerHTML]="html_agenda"></div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="mark_downer">
                      <label class="mt-1 mb-2 c_blue">
                        <i class="fas fa-fw fa-clock me-2"></i>Minutes
                        <i class="fas fa-fw fa-search-plus mx-2 p-2 pointer" title="Show Rendered Content" (click)="togglePreview('minutes')"></i>
                      </label>
                      <textarea class="form-control form-control-sm"
                                [(ngModel)]="minutesForm.content_minutes"
                                (ngModelChange)="onMarkdownChange('minutes')"
                                style="height:25vh"></textarea>
                    </div>
                    <div *ngIf="minutesForm.show_minutes" class="p-2 markup_scroll" [innerHTML]="html_minutes"></div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="mark_downer">
                      <label class="mt-1 mb-2 c_blue">
                        <i class="fas fa-fw fa-exclamation-triangle me-2"></i>Action Items
                        <i class="fas fa-fw fa-search-plus mx-2 p-2 pointer" title="Show Rendered Content" (click)="togglePreview('actionitems')"></i>
                      </label>
                      <textarea class="form-control form-control-sm"
                                [(ngModel)]="minutesForm.content_actionitems"
                                (ngModelChange)="onMarkdownChange('actionitems')"
                                style="height:25vh"></textarea>
                    </div>
                    <div *ngIf="minutesForm.show_actionitems" class="p-2 markup_scroll" [innerHTML]="html_actionitems"></div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12 text-center">
                    <button class="btn btn-lg btn-primary my-2" (click)="saveMinutes()">
                      <i class="fas fa-fw fa-save me-2"></i>Save Minutes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card mt-2">
      <div class="card-header bg_blue p-2">
        <div class="row c_white">
          <div class="col-9">
            <label class="my-1"><i class="fas fa-fw fa-save mx-2"></i>Saved Meeting Minutes</label>
            <span class="ms-3 badge">{{listMeetings.length}}</span>
          </div>
          <div class="col-3 text-end">
            <button type="button" class="btn btn-sm btn-primary" title="Toggle Saved Minutes Panel" (click)="toggleSaves()">
              <i [ngClass]="(showMinutesSaved) ? 'fas fa-fw fa-chevron-up' : 'fas fa-fw fa-chevron-down'"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body p-2" [ngClass]="(showMinutesSaved) ? 'd-block' : 'd-none'">
        <div class="row my-2">
          <div class="col-12">
            <ag-grid-angular class="ag-theme-alpine"
                             [rowData]="rowDataMinutes"
                             [columnDefs]="columnDefsList"
                             [getRowStyle]="getRowStyle"
                             [rowHeight]="28"
                             [headerHeight]="32"
                             (gridReady)="onMinutesGridReady($event)"
                             [rowSelection]="rowSelection"
                             (selectionChanged)="onSelectionChanged($event)"
                             style="width: 100%;height:50vh;border:0 !important">
            </ag-grid-angular>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    <div class="backdrop" data-bs-backdrop="true" [ngStyle]="{'display':showModal}"></div>
    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':showModal}" id="minutesModal">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="container-fluid p-0">
              <div class="row m-0 p-0">
                <div class="col-12 col-md-6 p-0 modal-title"></div>
                <div class="col-12 col-md-6 p-0 text-end">
                  <button type="button" class="btn btn-sm btn-light my-1" alt="Close" title="Close" (click)="toggleModal('hide')">
                    <i class="fas fa-fw fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <span></span>
          </div>
          <div class="modal-body">
            <app-form-party-external id="ctlPartyAdd" (partyToMinutesGrid)="addExternalCallback($event)">
            </app-form-party-external>
          </div>
          <div class="modal-footer text-center d-none">
            <button type="button" class="btn btn-dark my-1" title="Save">
              <i class="fas fa-fw fa-save"></i>
            </button>
            <button type="button" class="btn btn-light my-1" alt="Close" title="Close">
              <i class="fas fa-fw fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
